import React from 'react';
import {
  TableCell, Skeleton, Chip, Tooltip
} from '@mui/material';
import { Typography } from 'bso-ui';
import { timestampToDate } from 'helpers/formatters';
import useDetail from 'hooks/useDetail';
import API from 'common/api';

const ModemStatus = ({ type, hostname }) => {
  const query = {
    storeKey: `modem-status-${hostname}`,
    // eslint-disable-next-line max-len
    apiEndpoint: `${API.MONITORING_RESULTS}/${hostname}-${type}/check-rf-ping-${hostname?.toLowerCase()?.replaceAll('.', '-')}-${type.toLowerCase()}/`
  };

  const [{
    data, isError, error, isLoading
  }] = useDetail(query.storeKey, query.apiEndpoint, { refetchOnWindowFocus: false });

  const getPingStatus = (status, executed) => {
    let ping = '';
    let color = '';
    if (status === 0) {
      ping = 'Up';
      color = 'success';
    } else if ([1, 3].includes(status)) {
      ping = 'Check it and tell us';
      color = 'warning';
    } else {
      ping = 'Down';
      color = 'error';
    }
    return (
      <Tooltip title={timestampToDate(executed, 'yyyy-MM-DD, HH:mm:ss')}>
        <Chip
          size="small"
          label={ping}
          color={color}
          style={ping === 'Down' ? { animation: 'blinker 1s linear infinite' } : {}}
        />
      </Tooltip>
    );
  };

  if (isError) {
    return (
      <TableCell>{error?.response?.status === 502 ? (
        <Chip
          size="small"
          label="Not monitored"
        />
      ) : <Typography>Error</Typography>}
      </TableCell>
    );
  }

  if (isLoading || !data) {
    return (
      <TableCell><Skeleton variant="text" /></TableCell>

    );
  }

  return (
    <TableCell>
      {getPingStatus(data.check.status, data.check.executed)}
    </TableCell>
  );
};

export default ModemStatus;
